import React from 'react'
import { useNavigate } from 'react-router-dom'

import { PAGE_TITLE, ROUTE_TYPE } from '../../Configuration'
import usePageTitle from '../../hooks/use-page-title'
import './invalid-page-request.css'

const InvalidPageRequest = () => {
  const navigate = useNavigate()

  usePageTitle(PAGE_TITLE.ACCESS_DENIED)
  const redirectToHome = () => {
    navigate(`${ROUTE_TYPE}`)
  }
  
  return (
    <div className='d-flex align-items-center justify-content-center flex-column min-h-300 w-100'>
         <h2 aria-label="Sorry, this page hasn't been shared with you." className='AccessdeniedH2' tabIndex={0}>Sorry, this page hasn&apos;t been shared with you.</h2>
         <a className='btn' onClick={(e: any) => redirectToHome()}>&lt;&lt; Back to Home</a>
         </div>
  )
}
export default InvalidPageRequest
